module.exports = __webpack_public_path__ + "static/22-915e08c14d9bc1c36b28a7c9ac0d53a1.png";